import React from 'react'
import CommonPersonalSettingHome from '../../../common/pages/secure/PersonalSettingHome'
import PageHeader from '../../components/PageHeader'

class PersonalSettingHome extends CommonPersonalSettingHome {
  constructor (props) {
    super(props)
    this.state = {}
    this.userRoleUrl = 'company_user'
  }
  renderPageNavi () {
    return (
      <PageHeader title='個人設定' sub='こちらから個人設定を開始できます。' history={this.props.history} />
    )
  }
}

export default PersonalSettingHome



// WEBPACK FOOTER //
// ./src/company_user/pages/secure/PersonalSettingHome.js